import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (opportunities: ContentNugget[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Opportunities',
    description:
      'Internships and job opportunities at this employer. Can be filtered by type (Internships, Jobs).',
  });

  useRegisterAgentContext({
    kind: 'nuggetList',
    description: 'Career opportunities (internships and jobs) at this employer',
    nuggets: opportunities.map(toAgentContextNugget),
  });
};
